<template>
    <div class="home">
        <div class="link-content">
            <div @click="stepByStepOpen">
                
            <ButtonWithImage id="pop-up-survey" :title="'<b>Mehmet Kırcı <span>|</span>&nbsp;</b> Evser Teknik Servis Uzmanı'" :text="'4 SORUDA SUDAN GEÇİRMEDEN MÜKEMMEL TEMİZLİK TESTİ <br> <span>Testi çözün, uzmanından ipuçları alın, bulaşıkları bir daha sudan geçirmenize gerek kalmasın</span>'" :link="''" :image="'mehmet-kirci@2x.png'" />
            </div>
            <!-- <ButtonWithImage :text="'SEN DE SÖZ VER,\nTASARRUFA BAŞLA,\n25 TL İNDİRİM KAZAN'" :image="'faturaniyukleel.png'" :link="''" onclick="window.location.href = window.origin + '/tasarrufsozu'"/> -->
            <ButtonWithImage :text="'Türkiye’nin Su Kaynaklarını TAKİP ETMENİN artık <br> BİR yolu var'"
                             :image="'finish-su-endeksilogo.png'" :link="'/finish-su-endeksi'" :isBackground="true" v-bind:id="'button-finish-su-endeksilogo'"/>
            <!--<ButtonWithImage :text="'TANER ÖLMEZ İLE EBA TV SU KAHRAMANLARI'" :image="'z.png'" :link="'to:EbaTV'" />-->
            <ButtonWithImage :text="'25 LİTRE BELGESELİNİ İZLE'" :image="'athena.png'" :link="'to:Documentary25Litre'" v-bind:id="'button-athena'"/>
            <!--<ButtonWithImage :text="'FİNİSH QUANTUM MAX İLE 57 LİTRE SU TASARRUFU ETTİREN TABLET'" :link="'to:Story1'" :image="'finish.png'" />-->
            
        </div>
        <!--
        <div class="link-content">
            <ButtonWithImage :text="'MÜGE ANLI İLE GÜCÜMÜZYETER!'" :image="'mugeanli.png'" :link="'https://www.gucumuzyeter.com/'"/>
        </div>
        -->
        <div class="projects-promise">
            <WaterPrintPromise/>
            <SliderHome :slides="this.slide1" :slider-time="8" :slider-header="`Projeler`"
                        :slider-sub="{ text: 'Tüm Projeler', link: 'to:Projects'}"/>
        </div>
        <div class="news-academia">
            <SliderHome :slides="this.slide2" :slider-time="8" :slider-header="`Haberler`"
                        :slider-sub="{ text: 'Tüm Haberler', link: 'to:WaterAcademy'}"/>
            <WaterAcademia/>
        </div>
        <FooterHome/>
    </div>
</template>

<script>
    import EventBus from "../main";
    import ButtonWithImage from "../components/ButtonWithImage";
    import ButtonWithTransparent from "../components/ButtonWithTransparent";
    import ButtonBlueBackground from "../components/ButtonBlueBackground";
    import WaterPrintPromise from "../components/WaterPrintPromise";
    import SliderHome from "../components/SliderHome";
    import WaterAcademia from "../components/WaterAcademia";
    import FooterHome from "../components/FooterHome";

    export default {
        name: "Home",
        data() {
            return {
               
                slide1: [
                    {
                        'header': 'Kuyucuk Kuş Cenneti Can Suyuna Kavuştu',
                        'text': 'Gölün sahibi kuşlar evlerine geri dönmeye başladı',
                        'link': 'path:/projeler/kuyucuk',
                        'linkText': 'İncele',
                        'image': 'kuyucuk-black.jpg'
                    }
                    /* TODO: When client approves, uncomment this section. Currently this campaign is passive.
                    ,
                    {
                        'header': 'MÜGE ANLI İLE GÜCÜMÜZ YETER',
                        'text': 'Müge Anlı\'nın Finish desteğiyle girişimci kadınların hayalini gerçekleştiriyoruz',
                        'link': 'https://www.gucumuzyeter.com/',
                        'linkText': 'İncele',
                        'image': 'muge_anli_projeler.jpg'
                    }*/
                ],
                slide2: [
                    {
                        'header': 'GÜNEY AFRİKA’DA YENİDEN SU SIKINTISI',
                        'text': 'Güney Afrika’da 2018 yılında yaşanan kıtlık artık 2020’nin de gündemi oldu.',
                        'link': 'to:WaterAcademy',
                        'linkText': 'İncele',
                        'image': 'haberler_view@3x.png'
                    }
                ]
            }
        },
        mounted() {
            EventBus.$emit("home-active");
            EventBus.$emit('background-change', this.$route.name);
            EventBus.$emit('story-background', 'home');
            this.$store.commit('changeStory', 0);
            this.$store.commit('navigationStatus', 'home');
        },
        components: {
            ButtonBlueBackground,
            ButtonWithTransparent,
            ButtonWithImage,
            WaterPrintPromise,
            SliderHome,
            WaterAcademia,
            FooterHome
        },
        created() {
            $('body').removeClass('back-image');
        },
        methods: {
            stepByStepOpen() {
                EventBus.$emit('step-by-step-status')
                /*setTimeout(() => {
                var video1 = document.getElementById('videoStart');
                video1.currentTime = 0;
                video1.play();
                }, 100);
                */
                /*var scrollTop;
                if(window.innerWidth > 1000){
                    scrollTop = $(document).scrollTop() + 40;
                }else{
                    scrollTop = $(document).scrollTop();
                }
                setTimeout(() => {
                    $('.vue-form-wizard').css('top',scrollTop);
                }, 100);*/
            },
            
        }
    };
</script>

<style lang="scss">

    .ob-title-container .ob__title b span {
        color: #00a0e2;
    }
    #pop-up-survey .ob-image-container{
        margin-left: -26px;
        margin-top: 5px;
    }

    #pop-up-survey .ob-text-container {
        display: flex;
        flex-direction: column;
        padding-right: 0;
        justify-content: center;
        width: calc(100% - 100px);
    }
    
    #pop-up-survey .ob-text-container span {
        text-transform: none;
        
        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            font-size: 25px;
        }
    }

    #pop-up-survey .ob-image-container img {
        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            width: 225px;
        }
        
    }
    .home {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
            margin-top: -50px;
        }

        .link-content {
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            height: auto;
            flex-wrap: wrap;
            margin-top: 80px;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                flex-direction: column;
                margin-top: 0px;
            }
        }

        .bottom-content {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-bottom: 40px;

            & > p {
                width: 182px;
                font-family: "Quicksand", sans-serif, Tahoma;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
            }
        }


        .projects-promise {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 80px;
            width: 100%;
            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                flex-direction: column;
                width: 90%;
            }
        }

        .news-academia {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 80px;
            width: 100%;
            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                flex-direction: column;
                width: 90%;
            }
        }
    }
</style>
